<template>
    <LazyPagebuilderBlockResolver
        v-if="data"
        v-for="(block, index) in data?.pageBuilder"
        :id="'block-' + index"
        :blockTitle="block._type"
        :blockContent="block"
        :componentId="block._key"
        :shopwareId="shopwareId"
        :type="type"
        :pageTitle="data.title"
        :blog="blog" />
</template>

<script setup lang="ts">
    import { groq, useSanityQuery } from '~/composables/sanity/useSanityQuery';
    import type { MenuStyling } from '~/composables/useMenuStyling';

    const props = defineProps({
        type: String,
        id: String,
        shopwareId: String,
        blog: Boolean,
    });

    const pagebuilderQuery = groq`*[_type == "${props.type}" && _id == '${props.id}'] {
      title,
      metaDescription,
      menuStyling,
      pageBuilder[] {
      ...,
      _type == "ImageText" => {
        body[] {
          "link": internalLink->slug.current,
          ...
        },
      },
      _type == "PageContentHero" => {
        content[] {
          "link": internalLink->slug.current,
          ...
        },
      },
      _type == "VideoImage" => {
        "videoUrl": visualBlock.video.asset->url,
      },
      },
    }[0]`;

    interface PageBuilder {
        title?: string;
        metaDescription?: string;
        menuStyling?: MenuStyling | null;
        pageBuilder?: any[];
    }

    const { data } = await useSanityQuery<PageBuilder>(pagebuilderQuery);

    // Per-page menu styling from Sanity; the header reads this. Null = default styling.
    const menuStyling = useMenuStyling();
    menuStyling.value = data.value?.menuStyling ?? null;
    watch(data, newData => {
        menuStyling.value = newData?.menuStyling ?? null;
    });
</script>
